window.onload = function(){
    if($('#resend-link').length ) {
        document.getElementsByName("resend-link")[0].disabled = true;
        setTimeout(function () {
            var element = document.getElementsByName("resend-link")[0];
            element.disabled = false;
        }, 29000);
        var timeleft = 29;
        var downloadTimer = setInterval(function () {
            document.getElementById("countdown").innerHTML = " in " + timeleft + " seconds.";
            timeleft -= 1;
            if (timeleft <= 0) {
                clearInterval(downloadTimer);
                document.getElementById("countdown").innerHTML = " now."
            }
        }, 1000);
    }
}